import React, { useState } from "react";
import { getFromLocalStorage } from "../../../../../utils/common-utils";
import Swal from "sweetalert2";
import { BlockCpService, BlockCpUser } from "../../../../../api/Api";

const BlockService = ({
  setBlockServiceModal,
  editData,
  getAllData,
  getCount,
  cp,
}) => {
  const [blockMessage, setBlockMessage] = useState("");
  const [blockError, setBlockError] = useState(false);

  // block cp
  const handleBlockCpSubmit = async (e) => {
    e.preventDefault();
    if (!blockMessage) {
      setBlockError(true);
    } else {
      setBlockError(false);
      let payload = {
        userId: getFromLocalStorage("userData")?.id,
        id: editData?.id,
        status: 3,
        rejectReason: null,
        blockedMessage: blockMessage,
      };
      const response = await BlockCpService(payload);
      if (response?.statusDescription?.status == 200) {
        if (cp) {
          getAllData();
          getCount();
        }
        Swal.fire({
          icon: "success",
          text: response?.statusDescription?.description,
          confirmButtonText: "OK",
        });
        setBlockServiceModal(false);
        setBlockMessage("");
      } else {
        Swal.fire({
          icon: "info",
          text: response?.statusDescription?.description,
          confirmButtonText: "OK",
        });
      }
    }
  };
  return (
    <form onSubmit={handleBlockCpSubmit}>
      <textarea
        maxlength={50}
        class={`form-control ${
          blockError && !blockMessage ? "is-invalid" : ""
        }`}
        placeholder="Block Message"
        name="blockMsg"
        autocomplete="blockMsg"
        value={blockMessage}
        onChange={(e) => {
          setBlockMessage(e.target.value);
        }}
      ></textarea>
      {blockError && !blockMessage && (
        <div class="invalid-feedback d-block error">
          <div>Block Message is required.</div>
        </div>
      )}
      <div class="modal-footer border-0 justify-content-between px-0 mx-0">
        <button
          type="button"
          class="btn btn-danger m-0"
          aria-label="Close"
          onClick={() => {
            setBlockServiceModal(false);
            setBlockError(false);
            setBlockMessage("");
          }}
        >
          Cancel
        </button>
        <button type="submit" class="btn btn-primary m-0">
          Confirm
        </button>
      </div>
    </form>
  );
};

export default BlockService;
